const initialState={
	user:sessionStorage.getItem('id')?{id:sessionStorage.getItem('id'),
											name:sessionStorage.getItem('name'),
											usuario:sessionStorage.getItem('usuario'),
											tipo:Number( sessionStorage.getItem("tipo") )}:"",
	login:sessionStorage.getItem('login')?sessionStorage.getItem('login'):false
		
};


export default function loginReducer(state= initialState,action){
	switch(action.type){
     	case 'USER':
     		return {...state,user:action.payload};
     	case 'LOGIN':
     		return {...state,login:action.payload};
     	default:
     		return state
    
    }
}